<template>
  <div class="swatch-cont">
    <!-- ONE COLOR -->
    <div v-bind:class="[ 'swatch', `color-${colors.length}`]" v-if="colors">
      <div class="swatch-color" v-for="color in colors" v-bind:style="{ backgroundColor: `#${color}` }"></div>
    </div>
    <div class="swatch" v-if="backgroundUrl && !colors">
      <div class="swatch-color" v-bind:style="{ backgroundImage: `url(${backgroundUrl})`, backgroundPosition: classBackgroundPosition, width: '100%'}"></div>
    </div>
  </div>
</template>

<script>
  import _get from 'lodash/get'

  export default {
    props: ['color'],

    computed: {
      hasThumbnail () {
        if (this.color.name !== 'None') {
          return this.color.thumbnail
        }
      },
      colors () {
        let hexCode = _get(this, 'color.hex_code', '')
        if (hexCode) {
          return hexCode.split('/')
        }
        return null
      },
      backgroundUrl () {
        return this.hasThumbnail ? this.color.thumbnail : null
      },
      offsetX () {
        return this.hasThumbnail ? this.color.x_offset : null
      },
      offsetY () {
        return this.hasThumbnail ? this.color.y_offset : null
      },
      classBackgroundPosition () {
        return `calc(-650px - ${this.color.x_offset}px) calc(-120px - ${this.color.y_offset}px)`
      }
    },
    created () {
      // console.log('this.color', this.color)
    }
  }
</script>
